import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../../../core/services';
import { SimulatorStatusV2 } from '../components/simulator/models';

export const SESSIONS_QUERY_KEYS = {
  KEEP_SESSION_ALIVE: 'keepSessionAlive',
  SIMULATOR_STATUS: 'simulatorStatus',
} as const;

type UseKeepSessionAliveProps = {
  sessionId: number;
};

export const useKeepSessionAlive = ({ sessionId }: UseKeepSessionAliveProps) =>
  useQuery(
    [SESSIONS_QUERY_KEYS.KEEP_SESSION_ALIVE],
    () => ApiService.get<void>(`/v1/sessions/${sessionId}/keepalive`).then((response) => response.data),
    {
      enabled: false, // We only want to renew the session manually
    }
  );

type UsePollSimulatorStatus = {
  sessionId: number;
};

export const usePollSimulatorStatus = ({ sessionId }: UsePollSimulatorStatus) => {
  return useQuery({
    queryKey: [SESSIONS_QUERY_KEYS.SIMULATOR_STATUS, sessionId],
    queryFn: () =>
      ApiService.get<SimulatorStatusV2>(`/v2/sessions/${sessionId}/simulator-status`).then((response) => {
        return response.data;
      }),
    refetchInterval: 2000,
  });
};
